/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BytesLike,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  SafetyBoxStorage,
  SafetyBoxStorageInterface,
} from "../../../contracts/safetyBox/SafetyBoxStorage";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nameServiceKey_",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "sysAdmin_",
        type: "address",
      },
      {
        internalType: "address",
        name: "accessControl_",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "sysGetAdmin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetNameServiceAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetNameServiceKey",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetOutOfService",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetRevertMessage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetTransparent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
    ],
    name: "sysSetAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "input",
        type: "address",
      },
    ],
    name: "sysSetNameServiceAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "sysSetNameServiceKey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetOutOfService",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetRevertMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetTransparent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type SafetyBoxStorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SafetyBoxStorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SafetyBoxStorage__factory extends ContractFactory {
  constructor(...args: SafetyBoxStorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    nameServiceKey_: PromiseOrValue<BytesLike>,
    sysAdmin_: PromiseOrValue<string>,
    accessControl_: PromiseOrValue<string>,
    owner_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<SafetyBoxStorage> {
    return super.deploy(
      nameServiceKey_,
      sysAdmin_,
      accessControl_,
      owner_,
      overrides || {}
    ) as Promise<SafetyBoxStorage>;
  }
  override getDeployTransaction(
    nameServiceKey_: PromiseOrValue<BytesLike>,
    sysAdmin_: PromiseOrValue<string>,
    accessControl_: PromiseOrValue<string>,
    owner_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      nameServiceKey_,
      sysAdmin_,
      accessControl_,
      owner_,
      overrides || {}
    );
  }
  override attach(address: string): SafetyBoxStorage {
    return super.attach(address) as SafetyBoxStorage;
  }
  override connect(signer: Signer): SafetyBoxStorage__factory {
    return super.connect(signer) as SafetyBoxStorage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SafetyBoxStorageInterface {
    return new utils.Interface(_abi) as SafetyBoxStorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SafetyBoxStorage {
    return new Contract(address, _abi, signerOrProvider) as SafetyBoxStorage;
  }
}
